import { render, staticRenderFns } from "./Brother.vue?vue&type=template&id=91c76ef8&scoped=true&"
import script from "./Brother.vue?vue&type=script&lang=js&"
export * from "./Brother.vue?vue&type=script&lang=js&"
import style0 from "./Brother.vue?vue&type=style&index=0&id=91c76ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c76ef8",
  null
  
)

export default component.exports